





















































































import Vue from 'vue';
import { mapActions } from 'vuex';
import { IPaymentRequisition, IUser } from '@/models';
import EmployeeUserPicker from '../employee/EmployeeUserPicker.vue';

export default Vue.extend({
  name: 'PaymentRequisitionOwnerListMenu',

  components: { EmployeeUserPicker },

  props: {
    paymentRequisition: {
      type: Object as () => IPaymentRequisition,
      required: true
    },
    disabled: Boolean
  },

  data() {
    return {
      ownerLoading: false,
      ownerDialog: false,
      errorMessage: '',
      owner: null as null | number
    };
  },

  watch: {
    ownerDialog(value: boolean) {
      if (value) {
        if (this.paymentRequisition.owner) {
          this.owner =
            (this.paymentRequisition.owner as IUser).id ??
            (this.paymentRequisition.owner as number);
        }
      }
    }
  },

  methods: {
    ...mapActions({
      updatePaymentRequisitionOwner:
        'paymentRequisition/updatePaymentRequisitionOwner'
    }),

    closeDialog() {
      this.errorMessage = '';
      this.ownerLoading = false;
      this.ownerDialog = false;
    },

    async setPaymentRequisitionOwner(owner: number) {
      this.ownerLoading = true;
      await this.updatePaymentRequisitionOwner({
        paymentRequisitionId: this.paymentRequisition.id,
        owner
      })
        .then(() => {
          this.closeDialog();
        })
        .catch(() => {
          this.errorMessage = 'Error assigning owner';
          this.ownerLoading = false;
        });
    }
  }
});
